<template>
  <CContainer fluid>
    <h3>Oportunidades</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6" sm="6">
            <CButton 
              color="success" 
              class="mt-4"
              :to="`${rootPath}/agregar`">
              <CIcon name="cil-check-circle" class="mr-2" />
              <span class="align-middle">Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          :items="opportunities" 
          :fields="fields" 
          :items-per-page="itemsPerPage">
          <template #empresa="{ item }">
            <td>
              <h4>{{ item.empresa }}</h4>
              <div>
                <span>{{ item.identificacion }}</span>
              </div>
            </td>
          </template>
          <template #empleado="{item}">
            <td>
              <div>
                <i class="bi bi-person-workspace" />
                <span> {{ item.empleado }}</span>
              </div>
              <div>
                <span>{{ item.descripcion }}</span>
              </div>
            </td>
          </template>
          <template #prioridad="{item}">
            <td>
              <div>
                <i class="bi bi-cash-coin" />
                <span> {{ formatter.format(item.valor_NegocioPrevisto) }}</span>
              </div>
              <div>
                <CBadge :color="getColor(item.prioridad)" v-if="item.prioridad">{{ opportunityStatus[item.prioridad] }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #origen_Oportunidad="{item}">
            <td>
              <div>
                <span>{{ item.origen_Oportunidad }}</span>
              </div>
              <div>
                <span>{{ item.grupo_Oportunidad }}</span>
              </div>
              <div>
                <span>{{ item.fase_Venta }}</span>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#" @click="toggleDocument($event, item)" style="text-decoration: none;" class="mb-2 p-2">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"></CIcon>
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end">
                <a href="#" 
                  class="mr-3"
                  @click="event => openRightSideBar(event, item)">
                  <i class="bi bi-check2-circle h5"></i>
                  <i class="bi bi-arrow-left-right h5"></i>
                </a>
                <a href="#" 
                  class="mr-2" 
                  v-c-tooltip="'xxxxx'" 
                  @click="openModalSeriales($event, item.id_Documento)">
                  <i class="bi bi-upc-scan text-dark h4"></i>
                </a>
              </div>
              <CRow>
                <div class="ml-4"><strong>Descripción: </strong></div>
                <p class="mx-4">
                  {{item.descripcion}}
                </p>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination 
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page" 
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)" />
        </CCardBody>

        <CElementCover v-show="loading" />
    </CCard>

    <!-- Panel sidebar para formulario de seguimiento -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelTracking">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <h4>Seguimiento</h4>
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="trackingdocs_fields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="primary" 
                class="mr-2 d-inline-block" 
                :class="isValidForm ? '' : 'disabled'" 
                :disabled="!isValidForm"
                @click="saveTracking()">
                <CIcon name="cil-check-alt" />
                <span class="align-middle mr-2">Guardar</span>
              </CButton>
              <CButton 
                color="secondary" 
                class="mr-2 d-inline-block" 
                @click="(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  showPanelTracking = false;
                }">
                <CIcon name="cil-x" />
                <span class="align-middle mr-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

  </CContainer>
</template>
<script>
  import moment from 'moment'
  import { 
    dataGridOportunidades,
    guardarSeguimiento,
    dataListClasesSeguimientos
  } from '../../../../api'
  import { 
    errorMessage,
    formatter
  } from '../../../../general'
  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";
  import constants from "@/constants";

  const fields = [
    { 
      key: 'empresa', 
      label: 'Empresa', 
      _style:'text-align:center;'
    },
    { 
      key: 'empleado', 
      label: 'Empleado', 
      _style:'text-align:center;'
    },
    { 
      key: 'prioridad', 
      label: 'Prioridad', 
      _style:'text-align:center;'
    },
    { 
      key: 'origen_Oportunidad', 
      label: 'Clasificación', 
      _style:'text-align:center;'
    },
    { 
      key: 'info', 
      label: ''
    },
  ]

  export default {
    data() {
      const self = this
      return {
        fields,
        formatter,
        rootPath: "",
        loading: false,
        confirmationModal: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        opportunity2delete: "",
        opportunities: [],
        opportunityStatus: {
          'M': 'Muy Importante',
          'I': 'Importante',
          'B': 'Baja'
        },
        selectedOpportunity: {},
        now: moment(),
        showPanelTracking: null,
        trackingdocs_fields: [
          {
            key: 'trackingClass',
            value: '',
            type: 'select',
            prepend_content: {
              name: 'bookmark-check'
            },
            options: [],
            label: 'Clase Seguimiento: ',
            required: true
          },
          {
            key: 'dateTracking',
            value: '',
            type: 'date',
            prepend_content: {
              name: 'calendar-date'
            },
            label: 'Fecha Seguimiento: ',
            required: true,
            custom_validation(){
              return self.now.isSameOrBefore(`${self.trackingdocs_fields[1].value}T${self.trackingdocs_fields[2].value}`, 'minutes')
            }
          },
          {
            key: 'timeTracking',
            value: '',
            type: 'time',
            prepend_content: {
              name: 'clock'
            },
            label: 'Hora Seguimiento: ',
            required: true,
            custom_validation(){
              return self.now.isSameOrBefore(`${self.trackingdocs_fields[1].value}T${self.trackingdocs_fields[2].value}`, 'minutes')
            }
          },
          {
            key: 'comments',
            value: '',
            type: 'textarea',
            prepend_content: {
              name: 'chat-square-text'
            },
            label: 'Comentarios: ',
            required: true
          }
        ]
      }
    },
    components: {
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        try {
          const { count, results } = await dataGridOportunidades(this, page, search);
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.opportunities = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(e, item){
        e.stopPropagation()
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getColor(status) {
        if(status === 'M') return 'success'
        if(status === 'I') return 'warning'
        if(status === 'B') return 'default'
      },
      openRightSideBar(e, item) {
        e.stopPropagation();
        e.preventDefault();

        this.selectedOpportunity = item
        this.showPanelTracking = true
        this.now = moment()
        this.trackingdocs_fields[1].value = this.now.format('YYYY-MM-DD')
        this.trackingdocs_fields[2].value = this.now.format('HH:mm')
        this.trackingdocs_fields[0].value = ''
        this.trackingdocs_fields[3].value = ''
      },
      async saveTracking(){
        this.loading = true;

        try {
          const datosSeguimiento = {
            oportunidad: this.selectedOpportunity.id_Oportunidad,
            clase_Seguimiento: this.trackingdocs_fields[0].value,
            fecha_Hora: `${this.trackingdocs_fields[1].value} ${this.trackingdocs_fields[2].value}`,
            comentarios: this.trackingdocs_fields[3].value,
            activa_Recordatorio: true,
            estado: "A",
            personal: this.$store.state.user.data.id_Empleado,
            id_Usuario: this.$store.state.user.data.id_Usuario
          }

          await guardarSeguimiento(this, datosSeguimiento);

          this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
          })

          this.showPanelTracking = false
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: constants.messages.notDoneAdd,
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async getTrackingClasses() {
        try {
          const response = await dataListClasesSeguimientos(this)
          this.trackingdocs_fields[0].options = [
            {
              value: '',
              label: 'Seleccionar'
            },
            ...response.map(item => { 
              return { value: item.id_ClaseSeguimiento, label: item.descripcion
            }})
          ]
        } catch (error) {
          console.log(error)
        }
      },
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData(this.page, this.searchWord)
      this.getTrackingClasses()
    },
    computed: {
      isValidForm() {
        return this.trackingdocs_fields.every(field => {
          if(field.required) {
            if(field.key === 'dateTracking' || field.key === 'timeTracking') {
              return this.now.isSameOrBefore(`${this.trackingdocs_fields[1].value}T${this.trackingdocs_fields[2].value}`, 'minutes')
            }
            if(typeof field.value === 'string') {
              return field.value.length > 0
            }

            return field.value > 0
          }

          return true
        })
      }
    }
  }
</script>